module.exports = __webpack_public_path__ + "img/35.8abb6be7.png";